import { useQueryParams, useQueryUpdate } from '@shared/hooks'
import { defaultFilters } from '@shared/utils'
import { Input } from 'antd'
import { InputProps } from 'antd/lib'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

const { Search } = Input

type Props = InputProps & {
  enterButton?: boolean
  queryParam?: string
}

export const SearchInput = ({
  enterButton = false,
  queryParam = 'search',
  ...props
}: Props) => {
  const { t } = useTranslation()
  const params = useQueryParams()
  const { updateQuery } = useQueryUpdate()

  const defaultParams = { ...params, page: defaultFilters.page }

  const onSearch = (search: string) =>
    updateQuery({ ...defaultParams, [queryParam]: search })

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      updateQuery({
        ...defaultParams,
        [queryParam]: ''
      })
    }
  }

  return (
    <Search
      defaultValue={params[queryParam]}
      onChange={onChange}
      onSearch={onSearch}
      key={params[queryParam]}
      placeholder={props.placeholder || t('search')}
      allowClear
      enterButton={enterButton}
      {...props}
    />
  )
}
